import { useMemo } from 'react'
import { useCourseStats } from '@/hooks/stats'
import {
  CourseActivityChart,
  UserDistributionChart,
  ConversationTrendsChart,
  UserActivityChart,
} from '@/components/Stats'

export function StatsDashboard() {
  const { data: courseStats, isLoading: isCourseStatsLoading } = useCourseStats()

  const courseChartData = useMemo(() => {
    if (!courseStats) return []
    return courseStats.courseStats.map((stat) => ({
      name: stat.courseName,
      active: stat.activeConversations,
      total: stat.totalConversations,
      users: stat.totalUsers,
    }))
  }, [courseStats])

  return (
    <div className="space-y-8 min-w-0">
      <h1 className="text-2xl font-bold">Analytics Dashboard</h1>
      <div className="grid gap-4 min-w-0">
        <div className="grid gap-4 sm:grid-cols-1 xl:grid-cols-2 min-w-0">
          <CourseActivityChart courseChartData={courseChartData} loading={isCourseStatsLoading} />
          <UserDistributionChart courseChartData={courseChartData} loading={isCourseStatsLoading} />
        </div>
        <ConversationTrendsChart />
        <UserActivityChart />
      </div>
    </div>
  )
}
